module.exports = __webpack_public_path__ + "static/jam3-545138e2c34966ecda7eca41209dd9ac.svg";